module.exports = __webpack_public_path__ + "img/icon-sb-mattress-ultra-plus-color-36.b3373ed.svg";